var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"SHZLM20200224"},[_c('Banner',{attrs:{"banner":_vm.baseInfo.banner}}),_c('router-view'),_c('BottomTabbar',{attrs:{"tabs":_vm.option.tabs,"themeColor":_vm.option.themeColor}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }